var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-md p-4",class:_vm.backgroundColourClass},[_c('p',{staticClass:"text-sm",class:_vm.textColourClass},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }